import { parseISO, format } from 'date-fns'

import { ARTICLE_PAGEVIEW } from './../constants'
import { useGtmPageView } from './useGtmPageView'

export const useGtmArticlePageView = (article) => {
  useGtmPageView(() => ({
    event: ARTICLE_PAGEVIEW,
    living_article_id: article._id,
    living_article_catlog: article.articleClassification.name,
    living_article_tags: article.keywords
      .filter((keyword) => keyword.isVisible)
      .map((keyword) => keyword.name),
    living_article_date: format(
      parseISO(article.publishStartTime),
      'yyyy/MM/dd'
    ),
  }))
}
